module.exports = __webpack_public_path__ + "img/logo.3efdb77d.png";